/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Bento_TitleInputs */

const en_why_listening_bento_title = /** @type {(inputs: Why_Listening_Bento_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made for the way you actually read`)
};

const es_why_listening_bento_title = /** @type {(inputs: Why_Listening_Bento_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho para tu forma real de leer`)
};

/**
* | output |
* | --- |
* | "Made for the way you actually read" |
*
* @param {Why_Listening_Bento_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_bento_title = /** @type {((inputs?: Why_Listening_Bento_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Bento_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_bento_title(inputs)
	return en_why_listening_bento_title(inputs)
});